import { Button, Space } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import {
  CheckOutlined,
  ClearOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { maskCnpj } from "../../../utils/maskFunctions";
import { mostrarInfo } from "../../../utils/messages";
import { modalApi } from "../../../config/AntdGlobalProvider";


const CadInfoBotoes = (props: any) => {
  const navigate = useNavigate();

  function mostrarConfirmar() {
    if (props.checkedValues.length === 0) {
      mostrarInfo("Campo inválido", "Selecione pelo menos uma área para a certificadora.");
    } else {
      modalApi.confirm({
        title: props.manter === 1 ? "Deseja confirmar o cadastro?" : "Deseja confirmar as alterações?",
        width: "700px",
        icon: <ExclamationCircleOutlined />,
        content: "Certificadora: " + maskCnpj(props.form.getFieldValue("cnpj")) + " (" + props.form.getFieldValue("razaoSocial") + ")",
        okButtonProps: { id: 'ok' },
        onOk() {
          props.form.validateFields();
          window.scrollTo(0, 0)
          props.form.submit();
        },
        onCancel() { },
      });
    }
  }

  function limparCamposDesabilitar() {
    props.resetForm();

    props.form.setFieldsValue({
      "nuProcesso": "",
    });
    
    navigate("/certificadoras/consultarcertificadora");
  }

  function confirmaNovaConsulta(){
    if (props.manter ===3){
      modalApi.confirm({
        title: "Nova consulta",
        width: "700px",
        icon: <ExclamationCircleOutlined />,
        content: "Deseja abandonar a edição atual? As alterações não salvas serão perdidas",
        okButtonProps: { id: 'ok' },
        onOk() {
          novaConsulta();
        },
        onCancel() { },
      });
    } else novaConsulta();
  }

  function novaConsulta(){
    props.setManter(-1); // ESTADO INICIAL
    limparCamposDesabilitar();
    props.resetColor();
  }

  return (
    <>
      <PageHeader
        className='site-page-header'
        style={{ background: "#FFF" }}
        extra={
          <div
            style={{
              display: "flex",
              width: "max-content",
              justifyContent: "flex-end",
            }}
          >
            <Space>
              <Button
                style={{ display: props.manter >= 2 ? "inline" : "none" }}
                shape='round'
                onClick={() => confirmaNovaConsulta()}
                icon={<ClearOutlined />}
              >
                Nova consulta
              </Button>

              {/* CANCELAR EDIÇÃO */}
              <Button
                style={{ display: props.manter === 3 ? "inline" : "none" }} // SOMENTE PARA EDIÇÃO
                shape='round'
                onClick={() => {
                  props.setManter(2); // ESTADO DETALHAR
                  window.scrollTo(0, 0)
                }}
                icon={<ClearOutlined />}
              >
                Cancelar
              </Button>

              <Button
                style={{ display: props.manter === 2 ? "inline" : "none" }}
                disabled={props.desabilitaBtnEditar ? props.desabilitaBtnEditar() : true}
                shape='round'
                onClick={() => {
                  props.setManter(3);
                }}
                type='primary'
                icon={<ClearOutlined />}
              >
                Editar
              </Button>

              {/* CANCELAR INCLUSÃO */}
              <Button
                style={{ display: (props.manter === 1) ? "inline" : "none" }} // INSERIR 
                // disabled={props.desabilitaBotoes()}
                shape='round'
                onClick={() => {
                  props.setManter(1)
                  navigate("/certificadoras/consultarpessoajuridica");
                }}
                icon={<ClearOutlined />}
              >
                Cancelar
              </Button>

              <Button
                style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INSERIR OU ALTERAR
                // disabled={props.desabilitaBotoes()}
                shape='round'
                onClick={() => {
                  props.resetColor();
                  mostrarConfirmar();
                }}
                type='primary'
                icon={<CheckOutlined />}
              >
                Salvar
              </Button>

            </Space>
          </div>
        }
      />
    </>
  );
};

export default CadInfoBotoes;
